import React from "react";
import IPage from "../../interfaces/page"
import PaymentComponent from "../../components/Payment/Payment.component";

const PaymentPage: React.FunctionComponent<IPage> = (props: IPage) => {
  return <PaymentComponent></PaymentComponent>;
};

export default PaymentPage;
